import React from 'react';
import { Header } from 'semantic-ui-react';
import ErrorContainer from './ErrorContainer';

const Error403 = ({height}) => (
    <ErrorContainer height={height}>
        <Header as='h1' color='primary' textAlign='center'>
            Restricted Access
        </Header>
        <Header as='h5'>
            Additional permissions required. Contact your account administrator.
        </Header>
    </ErrorContainer>
)

export default Error403;
